import { ref } from 'vue';

interface NotificationOptions {
  title?: string;
  text: string;
  details?: string;
  timeout?: number;
}

export function useSnackbar() {
  const snackbar = ref({
    show: false,
    color: '',
    text: '',
    timeout: 5000,
    location: 'top right'
  });

  const show = (options: NotificationOptions & { color: string }) => {
    snackbar.value = {
      show: true,
      color: options.color,
      text: options.text,
      timeout: options.timeout || 5000,
      location: 'top right'
    };
  };

  const success = (options: NotificationOptions) => {
    show({ ...options, color: 'success' });
  };

  const error = (options: NotificationOptions) => {
    show({ ...options, color: 'error' });
  };

  const warning = (options: NotificationOptions) => {
    show({ ...options, color: 'warning' });
  };

  const info = (options: NotificationOptions) => {
    show({ ...options, color: 'info' });
  };

  return {
    snackbar,
    success,
    error,
    warning,
    info
  };
} 